import { Link } from '@tanstack/react-router'
import { AppLayout, Card, RequireSession } from 'vcode-commons-ui'

export default function HomePage() {
  return (
    <RequireSession>
      {(user) => (
        <AppLayout user={user}>
          <h1 className="text-2xl font-semibold tracking-tight text-neutral-900 dark:text-neutral-50">
            Bonjour {user.displayName}
          </h1>
          <p className="mt-2 text-sm text-neutral-600 dark:text-neutral-400">
            Vous etes connecte en tant que <span className="font-medium">{user.email}</span>.
          </p>

          <div className="mt-8 grid gap-4 sm:grid-cols-2">
            <Card title="Mes comptes bancaires">
              <p className="text-sm text-neutral-600 dark:text-neutral-400">
                Declarez vos comptes : banque, libelle et IBAN. L'import de vos releves arrive prochainement.
              </p>
              <div className="mt-3 flex flex-wrap gap-4">
                <Link
                  to="/accounts"
                  className="text-sm font-medium text-neutral-900 underline underline-offset-4 dark:text-neutral-100"
                >
                  Voir mes comptes
                </Link>
                <Link
                  to="/accounts/new"
                  className="text-sm font-medium text-neutral-900 underline underline-offset-4 dark:text-neutral-100"
                >
                  Ajouter un compte
                </Link>
              </div>
            </Card>

            <Card title="Securite">
              <p className="text-sm text-neutral-600 dark:text-neutral-400">
                Protegez votre compte avec une application d'authentification.
              </p>
              <Link
                to="/profile"
                className="mt-3 inline-block text-sm font-medium text-neutral-900 underline underline-offset-4 dark:text-neutral-100"
              >
                Gerer mon profil
              </Link>
            </Card>
          </div>
        </AppLayout>
      )}
    </RequireSession>
  )
}
